module.exports = __webpack_public_path__ + "static/media/background-static-bluegreen.cad79353.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/UI/StaticPage/background-static-bluegreen.jpg
// module id = 1049
// module chunks = 0